<template>
    <div class="max-w-3xl mx-auto lg:max-w-4xl" :class="noPadding ? '' : 'px-4 sm:px-6 lg:px-8'">
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        noPadding: Boolean,
    },
}
</script>
